module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', [_c('v-card', [_c('v-badge', {
    attrs: {
      "left": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v("6")])]), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "text-md-center"
  }, [_c('h3', [_vm._v("Kangaroo Valley Safari")]), _vm._v(" "), _c('div', {
    staticClass: "text-md-center"
  }, [_vm._v("Located two hours south of Sydney in the "), _c('br'), _vm._v("Southern Highlands of New South Wales, ...")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "orange"
    }
  }, [_vm._v("Explore")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-482ee27e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Project.vue
// module id = 88
// module chunks = 2